export const UPLOAD_RESULTS_REQUEST = 'UPLOAD_RESULTS_REQUEST';

export const uploadResultsRequest = ( formData ) => ({
    type: UPLOAD_RESULTS_REQUEST,
    payload: { formData }
});
